import { render, staticRenderFns } from "./VmProductManager.vue?vue&type=template&id=19951a42&scoped=true"
import script from "./VmProductManager.vue?vue&type=script&lang=js"
export * from "./VmProductManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19951a42",
  null
  
)

export default component.exports